import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import { SourceControlProvider, CmsVendor } from "@modules/graphql/types"

export type UseProvisionSiteParams = {
  setError: (e: { message: string }) => void
}

type ProvisionSiteMutationVariables = {
  organizationId: string
  provider: SourceControlProvider
  selectedInstallationId: string
  projectName: string
  vendor: CmsVendor
  templateId: string
}

export function useProvisionSite({ setError }: UseProvisionSiteParams) {
  const [provisionSiteMutation, { loading }] = useMutation(
    createProvisionedSite
  )

  const provisionSite = ({
    organizationId,
    provider,
    selectedInstallationId,
    projectName,
    vendor,
    templateId,
    successAction,
  }: ProvisionSiteMutationVariables & {
    successAction: (siteId: string) => void
  }) =>
    provisionSiteMutation({
      variables: {
        organizationId,
        provider,
        selectedInstallationId,
        projectName,
        vendor,
        templateId,
      },
    })
      .then(({ data }) => {
        const provisionSite = data && data.createProvisionedSite
        const validation = provisionSite && provisionSite.validation
        const site = provisionSite && provisionSite.site
        const siteId = site && site.id
        const success = validation && validation.success

        if (success) {
          return successAction(siteId)
        }

        return setError(validation as { message: string })
      })
      .catch(err => setError(err))

  return [provisionSite, loading] as const
}

const createProvisionedSite = gql`
  mutation createProvisionedSite(
    $organizationId: UUID
    $provider: SourceControlProvider
    $selectedInstallationId: String!
    $projectName: String!
    $vendor: CmsVendor!
    $templateId: String!
  ) {
    createProvisionedSite(
      organizationId: $organizationId
      selectedInstallationId: $selectedInstallationId
      projectName: $projectName
      vendor: $vendor
      provider: $provider
      templateId: $templateId
    ) {
      site {
        id
      }
      validation {
        success
        message
        errorType
      }
    }
  }
`
